import Cookies from 'js-cookie';
import gtm from '@periodica/analytics/gtm';
import wrapWithProvider from './wrap-with-provider';

import './src/styles/index.scss';

export const wrapRootElement = wrapWithProvider;

const sendCurrentBranchEvent = () => {
  const testVariable = Cookies.get('ab_bucket');
  if (testVariable) {
    gtm.logEvent({
      name: `e_site_abtest_${testVariable.replace(':', '_')}`,
    });
  }
};

const initScripts = () => {
  sendCurrentBranchEvent();
};

export const onClientEntry = initScripts;
